(() => {
  if (window.UnsolicitedParallax) {
    window.UnsolicitedParallax.refresh();
    return;
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const roots = new Set();
  const visibleRoots = new Set();
  let frame = null;

  const render = () => {
    frame = null;
    if (reducedMotion.matches) return;

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    visibleRoots.forEach((root) => {
      const rect = root.getBoundingClientRect();
      const distanceFromCenter = rect.top + rect.height / 2 - viewportHeight / 2;
      const travel = Math.max(viewportHeight + rect.height, 1);
      const progress = Math.max(-1, Math.min(1, distanceFromCenter / travel));
      root.style.setProperty('--ua-parallax-y', `${(progress * -56).toFixed(2)}px`);
    });
  };

  const requestRender = () => {
    if (frame === null) frame = window.requestAnimationFrame(render);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) visibleRoots.add(entry.target);
        else visibleRoots.delete(entry.target);
      });
      requestRender();
    },
    { rootMargin: '18% 0px 18% 0px' }
  );

  const refresh = () => {
    document.querySelectorAll('[data-ua-parallax-root]').forEach((root) => {
      if (roots.has(root)) return;
      roots.add(root);
      observer.observe(root);
    });
    requestRender();
  };

  const resetMotion = () => {
    if (reducedMotion.matches) {
      roots.forEach((root) => root.style.removeProperty('--ua-parallax-y'));
    }
    requestRender();
  };

  window.addEventListener('scroll', requestRender, { passive: true });
  window.addEventListener('resize', requestRender, { passive: true });
  window.addEventListener('pageshow', requestRender);
  reducedMotion.addEventListener?.('change', resetMotion);

  window.UnsolicitedParallax = { refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();
